export const FINDINGS_CLASSIFICATION_GROUP_KEY_SEPARATOR = ' | ';

export const resolveClassificationGroupKey = ({
  cweIds,
  owaspCategory,
}: {
  cweIds?: readonly string[] | null;
  owaspCategory?: string | null;
}): string => {
  const owasp = owaspCategory?.trim() ?? '';
  const cwes = [
    ...new Set(
      [...(cweIds ?? [])]
        .map((id) => id.trim())
        .filter((id): id is string => id.length > 0),
    ),
  ].sort((left, right) => left.localeCompare(right));

  return [owasp, ...cwes]
    .filter(Boolean)
    .join(FINDINGS_CLASSIFICATION_GROUP_KEY_SEPARATOR);
};
